import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightListStyle = styled('div')`
  .insightlist {
    &--items {
      ${media.desktop} {
        display: flex;
        flex-wrap: wrap;
      }
    }
    &--item {
      cursor: pointer;
      display: block;
      ${media.desktop} {
        width: 304px;
        flex: none;
      }
      ${media.mobile} {
        padding: 12px 0px;
      }

      &:not(:first-of-type) {
        ${media.mobile} {
          border-top: 1px solid #e0e0e0;
        }
      }
      &:nth-of-type(3n),
      &:nth-of-type(3n-1) {
        ${media.desktop} {
          margin-left: 16px;
        }
      }
    }
    &--pagination {
      ${media.mobile} {
        margin-left: -20px;
        width: calc(100% + 40px);
      }
      ${media.desktop} {
        margin-top: 5px;
      }
    }
  }
`;

export default InsightListStyle;
